import { SR_API_ACTION_UTILITY_PARTNER_GET_LIST } from 'api/utilityActionTypes';

export default async function getList({ state, utilityApiClient }, { forceRefresh = false } = {}) {
  const statePath = ['utilityPartners', 'list'];

  if (!forceRefresh && state.get(statePath)) {
    return state.get(statePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_GET_LIST,
    state: state,
    onSuccess(utilityPartnerList) {
      if (utilityPartnerList) {
        state.set(statePath, utilityPartnerList);
      }
    },
  });
}
